module.exports = __webpack_public_path__ + "static/img/tdf-event-succes.fedbb57.png";